import { LemniscateLoader } from './LemniscateLoader'
import s from './TenFourLoader.module.css'

interface TenFourLoaderProps {
  label?: string
  compact?: boolean
  /** Play the spiral-into-lemniscate intro before the loop — route-level long loads only. */
  intro?: boolean
  className?: string
}

/** The Ten Four loading loop: the brand lemniscate traced by the solid-orange snake. */
export function TenFourLoader({
  label = 'Loading…',
  compact = false,
  intro = false,
  className,
}: TenFourLoaderProps) {
  const classes = [s.root, compact ? s.compact : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} role="status" aria-live="polite">
      <LemniscateLoader
        state="loading"
        intro={intro}
        size={compact ? 72 : 96}
        className={s.mark}
      />
      <span className={s.label}>{label}</span>
    </div>
  )
}
